
import React from "react";

const Page = ({ poem }) => {
    return (
            <div className="pahe container">
            {poem.paragraphs.map((para, index) => (
            <p key={index}>
                {para.split("\n").map((line, i) => (
                <span key={i}>
                    {line}
                    <br />
                </span>
                ))}
            </p>
            ))}
            </div>
    );
  };
  
  export default Page;